import { setTimeout, clearTimeout } from "../../utils/timers";
const RRWEB_EVENT_TYPE_FULL_SNAPSHOT = 2;
const RRWEB_EVENT_TYPE_META = 4;
/**
 * Buffers rrweb events and hands them out as chunks. A chunk closes when its serialized size reaches
 * `maxBytes`, when `maxMillis` have passed since its first event, when a new full snapshot begins, or when
 * `flush()` is called. Events are serialized once, on arrival, so a flush is a join and not a second stringify.
 */
export function newChunker(opts) {
    let serialized = [];
    let byteSize = 0;
    let hasSnapshot = false;
    let startTime = 0;
    let endTime = 0;
    let seq = 0;
    let pendingFlushTimeout = null;
    return { add, flush, discard };
    function add(event) {
        // A Meta event announces a new full snapshot. Close the current chunk first so the snapshot starts a fresh
        // one and a replay can begin at that chunk.
        if (event.type === RRWEB_EVENT_TYPE_META && serialized.length > 0) {
            flush();
        }
        const json = JSON.stringify(event);
        if (json == null)
            return;
        if (serialized.length === 0) {
            startTime = event.timestamp;
            pendingFlushTimeout = setTimeout(flush, opts.maxMillis);
        }
        serialized.push(json);
        byteSize += json.length;
        endTime = event.timestamp;
        if (event.type === RRWEB_EVENT_TYPE_FULL_SNAPSHOT) {
            hasSnapshot = true;
        }
        if (byteSize >= opts.maxBytes) {
            flush();
        }
    }
    function discard() {
        clearPendingFlush();
        serialized = [];
        byteSize = 0;
        hasSnapshot = false;
    }
    function clearPendingFlush() {
        if (pendingFlushTimeout != null) {
            clearTimeout(pendingFlushTimeout);
            pendingFlushTimeout = null;
        }
    }
    function flush() {
        clearPendingFlush();
        if (serialized.length === 0)
            return;
        const chunk = {
            seq: seq++,
            body: "[" + serialized.join(",") + "]",
            eventCount: serialized.length,
            hasSnapshot,
            startTime,
            endTime,
        };
        serialized = [];
        byteSize = 0;
        hasSnapshot = false;
        opts.onChunk(chunk);
    }
}
